import { TAXONOMY_SKIP_SEGMENT } from 'src/adapters/pageURLToStore/taxonomyPath';
import type { Facet } from 'src/redux/productsQuery/types/Facet';
import type { TaxonomyAttribute } from 'src/redux/productsQuery/types/ProductsQueryState';

export const deriveTaxonomyLevelsFromFacets = (
  facets: Facet[],
  taxonomyAttributes: TaxonomyAttribute[],
): string[] => {
  if (taxonomyAttributes.length === 0) {
    return [];
  }

  const facetByAlias = new Map(facets.map((facet) => [facet.alias, facet]));

  const slots: string[] = taxonomyAttributes.map((alias) => {
    const facet = facetByAlias.get(alias);
    const activeOptions = facet?.options.filter((option) => option.active) ?? [];
    return activeOptions.length > 0
      ? activeOptions
          .map((o) => o.value)
          .sort()
          .join(',')
      : TAXONOMY_SKIP_SEGMENT;
  });

  while (slots.length > 0 && slots[slots.length - 1] === TAXONOMY_SKIP_SEGMENT) {
    slots.pop();
  }

  return slots;
};
